import {
  EXPORT_ZIP_FORM_FIELD_CHATS_FILES,
  EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY,
} from './RequestExportEmailsFilesChatsModal.constants'

export function getSelectedZipFieldIds(values) {
  return Object.keys(values).filter(
    key =>
      values[key] &&
      key !== EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY &&
      key !== EXPORT_ZIP_FORM_FIELD_CHATS_FILES
  )
}
